import React from 'react';
import PropTypes from 'prop-types';
import { Panel, PanelGroup } from 'react-resizable-panels';
import { ResizeHandle } from '../../../SharedComponents/ThreeColumnLayout/ResizeHandle';
import SignalBucketComponent from './SignalBucket/SignalBucketComponent';
import SignalPickerComponent from './SignalPicker/SignalPickerComponent';
import './style.scss';

const SelectionPanelComponent = ({
    selectedAsset,
    selectedAssetCapability,
    hasActiveSubscription,
    kpiListLoadingStatus,
    kpiList,
    chartData,
    offGraphSignals,
    loadingOffGraphSignalKeys,
    activeTab,
    selectedKPIType,
    onClearBucket,
    onAddSameSignals,
    onSelectSignal,
    onDeselectSignal,
    isSignalSelected,
    onHideOnGraphSignal,
    onPromoteOffGraphSignal,
    onRemoveOffGraphSignal,
    onComparisonItemClick,
    selectedComparisonAssetId,
    selectedComparisonOverrideKey,
    getComparisonItemSelectionKey,
    sameSignalsCount,
    lockedSignalKey,
    lockedSignalSelectValue,
    lockedSignalName,
    scatterHistogramSignals,
    scatterHistogramAssistCard,
    onAddLockedSignal,
    onChangeLockedSignal
}) => {
    return (
        <div className='selection-panel'>

            <div className='selection-panel-body'>
                <PanelGroup
                    direction='vertical'
                    className='selection-panel-inner-panel-group'
                >
                    <Panel defaultSize={50} minSize={25}>
                        <div className='selection-panel-bucket-section'>
                            <SignalBucketComponent
                                chartData={chartData}
                                offGraphSignals={offGraphSignals}
                                loadingOffGraphSignalKeys={loadingOffGraphSignalKeys}
                                activeTab={activeTab}
                                onClear={onClearBucket}
                                onHideOnGraphSignal={onHideOnGraphSignal}
                                onPromoteOffGraphSignal={onPromoteOffGraphSignal}
                                onRemoveOffGraphSignal={onRemoveOffGraphSignal}
                                onComparisonItemClick={onComparisonItemClick}
                                selectedComparisonAssetId={selectedComparisonAssetId}
                                selectedComparisonOverrideKey={selectedComparisonOverrideKey}
                                getComparisonItemSelectionKey={getComparisonItemSelectionKey}
                                lockedSignalKey={lockedSignalKey}
                                lockedSignalSelectValue={lockedSignalSelectValue}
                                lockedSignalName={lockedSignalName}
                                scatterHistogramSignals={scatterHistogramSignals}
                                hasActiveSubscription={hasActiveSubscription}
                                onChangeLockedSignal={onChangeLockedSignal}
                            />
                        </div>
                    </Panel>

                    <ResizeHandle className='selection-panel-inner-resize-handle ResizeHandle2' />

                    <Panel defaultSize={50} minSize={25}>
                        <div className='selection-panel-picker-section'>
                            <SignalPickerComponent
                                selectedAsset={selectedAsset}
                                selectedAssetCapability={selectedAssetCapability}
                                kpiListLoadingStatus={kpiListLoadingStatus}
                                kpiList={kpiList}
                                chartData={chartData}
                                activeTab={activeTab}
                                selectedKPIType={selectedKPIType}
                                onAddSameSignals={onAddSameSignals}
                                onSelectSignal={onSelectSignal}
                                onDeselectSignal={onDeselectSignal}
                                isSignalSelected={isSignalSelected}
                                sameSignalsCount={sameSignalsCount}
                                lockedSignalKey={lockedSignalKey}
                                lockedSignalName={lockedSignalName}
                                scatterHistogramAssistCard={scatterHistogramAssistCard}
                                onAddLockedSignal={onAddLockedSignal}
                                onChangeLockedSignal={onChangeLockedSignal}
                            />
                        </div>
                    </Panel>
                </PanelGroup>
            </div>
        </div>
    );
};

SelectionPanelComponent.propTypes = {
    selectedAsset: PropTypes.object,
    selectedAssetCapability: PropTypes.object,
    hasActiveSubscription: PropTypes.bool,
    kpiListLoadingStatus: PropTypes.string,
    kpiList: PropTypes.object,
    chartData: PropTypes.array,
    offGraphSignals: PropTypes.array,
    loadingOffGraphSignalKeys: PropTypes.instanceOf(Set),
    activeTab: PropTypes.string,
    selectedKPIType: PropTypes.string,
    onClearBucket: PropTypes.func,
    onAddSameSignals: PropTypes.func,
    onSelectSignal: PropTypes.func,
    onDeselectSignal: PropTypes.func,
    isSignalSelected: PropTypes.func,
    onHideOnGraphSignal: PropTypes.func,
    onPromoteOffGraphSignal: PropTypes.func,
    onRemoveOffGraphSignal: PropTypes.func,
    onComparisonItemClick: PropTypes.func,
    selectedComparisonAssetId: PropTypes.string,
    selectedComparisonOverrideKey: PropTypes.string,
    getComparisonItemSelectionKey: PropTypes.func,
    sameSignalsCount: PropTypes.number,
    lockedSignalKey: PropTypes.string,
    lockedSignalSelectValue: PropTypes.string,
    lockedSignalName: PropTypes.string,
    scatterHistogramSignals: PropTypes.array,
    scatterHistogramAssistCard: PropTypes.shape({
        type: PropTypes.string,
        signalName: PropTypes.string,
        assetName: PropTypes.string,
        assetType: PropTypes.string,
        lockedAssetType: PropTypes.string,
    }),
    onAddLockedSignal: PropTypes.func,
    onChangeLockedSignal: PropTypes.func,
};

export default SelectionPanelComponent;
